<template>
<div class="drawerWrap regionAddOrEdit">
  <div class="drawerBody">
      <div class="addform">
          <el-form class="formBox1" ref="adduserForm" :model="adduserForm" :rules="rules" label-position="right" label-width="70px">
            <el-form-item class="belongTypeItem" label="区域：" prop="regionId">
              <treeselect
                v-model="adduserForm.regionId"
                :options="regionOptions"
                :multiple="false"
                :load-options="loadOptions"
                @select="treeEven"
                placeholder="请选择区域"/>
                <!-- :normalizer="normalizer" -->
              <!-- <treeselect v-model="adduserForm.regionId" @select="treeEven" :normalizer="normalizer" :flat="true" :multiple=false :defaultExpandLevel="Infinity" :options="regionOptions" placeholder="请选择区域"/> -->
            </el-form-item>
          </el-form>
      </div>
      <div class="addform1">
        <tree-table-person @nickName="nickName" :pageSizes="[10, 20, 50]" :pages="pagination" :loading="tableLoading" @currentChange="treeCurrentChange" @sizeChange="treeSizeChange" :sendTreeData="sendTreeData" :modulesData="chargePersonLists" :treeTableLabel="treeTableLabel" :isEdit="addOrEditPar.type === 'edit'" @chooseAll='chooseAll' ref="treeRef" @sendCheckNode="sendCheckNode"></tree-table-person>
      </div>
      <div class="addform2">
        <tree-table @nickName1="nickName1" :pageSizes1="[10, 20, 50]" :pages1="pagination1" :loading1="tableLoading1"  @currentChange1="treeCurrentChange1" @sizeChange1="treeSizeChange1" :sendTreeData1="sendTreeData1" :modulesData1="installPersonLists" :treeTableLabel="treeTableLabel" :isEdit="addOrEditPar.type === 'edit'" @chooseAll1='chooseAll1' ref="treeRef1" @sendCheckNode1="sendCheckNode1"></tree-table>
      </div>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="formSubmit" :disabled="(chargePersonLists.length==0&&installPersonLists.length==0)||(this.modulesCheckArr.length==0&&this.modulesCheckArr1.length==0)" :loading="btnLoading">{{ btnLoading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelTreeModel()">取 消</el-button>
  </div>
</div>
</template>

<script>
import {LOAD_CHILDREN_OPTIONS, Treeselect} from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeTable from '@/components/regionalManagement/TreeTable'
import TreeTablePerson from '@/components/regionalManagement/TreeTablePerson'
export default {
  components: {
    TreeTable,TreeTablePerson,Treeselect
  },
  props: {
    addOrEditPar: {
      type: Object,
      default: () => ({})
    },
    btnLoading :{
      type: Boolean,
      default: () => (false)
    },
  },
  data() {
    return {
      tableLoading: false,
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableLoading1: false,
      pagination1: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      adduserForm:{
        regionId:null
      },
      rules:{
        regionId: [{
          required: true,
          message: "请选择区域",
          trigger: "blur"
        }]
      },
      regionOptions:[{
        id: 0,
        label: '区域机构',
        value: 0,
        isDefaultExpanded: true,
        children: null
      }],
      regionName:'',
      treeTableLabel: ["登录名", "昵称"],
      modulesCount: 0,
      // 树节点选中传入的值-----------------
      modulesCheckArr: [],
      modulesCheckArr1: [],
      // 树节点选中传入的值-----------------
      // 父穿子-----tree
      sendTreeData: [],
      sendTreeData1: [],
      // 添加========================
      chargePersonLists: [],
      installPersonLists: [],
      showContent: false,
      showContent1: false,
      nickNameSearch1:'',
      nickNameSearch:''
    }
  },
  mounted() {
  },
  created() {
    // this.showRegionOptions()
    this.getChargePerson()
    this.getInstallPerson()
  },
  methods: {
    loadOptions({ action, parentNode, callback }) {
      if (action === LOAD_CHILDREN_OPTIONS) {
        let id = parentNode.id
        this.getTreeNode(id).then(res => {
          if (res.code === 200) {
            let children = res.data && res.data.map(item => {
              if (!item.isLeaf) item.children = null
              return item
            })
            parentNode.children = children
          }
          callback()
        })
      }
    },
    getTreeNode (pid = 0) {
      return new Promise((resolve, reject) => {
        this.request.get(`/front/device/region/findTreeNofenjiById?id=${pid}`).then(res => {
          resolve(res)
        }).catch(e => reject(e))
      })
    },
    nickName(data){
      // console.log(data);
      this.pagination.currentPage = 1
      this.nickNameSearch =data
      this.getChargePerson()
    },
    nickName1(data){
      this.pagination1.currentPage = 1
      this.nickNameSearch1 =data
      this.getInstallPerson()
    },
    treeCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getChargePerson()
    },
    //表格展示条数变化时
    treeSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.getChargePerson()
    },
    treeCurrentChange1(val) {
      // console.log(val);
      this.pagination1.currentPage = val;
      this.getInstallPerson()
    },
    //表格展示条数变化时
    treeSizeChange1(val) {
      this.pagination1.pageSize = val;
      this.pagination1.currentPage = 1;
      this.getInstallPerson()
    },
    showRegionOptions() {
      let params ={
        id : 0
      }
      this.request
        .get("/front/device/region/findTreeNoTerminalById",params)
        .then(rs => {
          if (200 === rs.code) {
            let RegionArr = rs.data;
            this.regionOptions = RegionArr && RegionArr.length ? RegionArr : [];
            if(this.storage.getSession('currentTreeId')){
              this.adduserForm.regionId = this.storage.getSession('currentTreeId')?this.storage.getSession('currentTreeId'):null
              // console.log(this.storage.getSession('currentTreeId'));
              // console.log(this.storage.getSession('currentTreeLabel'));
              this.regionName = this.storage.getSession('currentTreeLabel')? this.storage.getSession('currentTreeLabel'):''
              this.getPersonInfo(this.adduserForm.regionId)
            }
          } else {
            this.msg.error(rs.msg);
          }
        })
        .catch(e => this.msg.error(e));
    },
    getChargePerson(){
      let params = {
        name:'负责人角色',
        isSystem:1
      }
      this.request.get('/front/system/role/query',params).then(rs => {
        // console.log(rs);
        if (rs.code === 200) {
          let personData = rs.data[0]
          this.getUserLists(personData.id)
        } else {
          this.msg.error(rs.msg);
        }
      })
    },
    getInstallPerson(){
      let params = {
        name:'安装员角色',
        isSystem:1
      }
      this.request.get('/front/system/role/query',params).then(rs => {
        // console.log(rs);
        if (rs.code === 200) {
          let personData = rs.data[0]
          this.getUserLists1(personData.id)
        } else {
          this.msg.error(rs.msg);
        }
      })
    },
    getUserLists1(id) {
      this.showContent1 = false
      this.installPersonLists= []
      let params = {
        roleIds: id,
        page:this.pagination1.currentPage,
        pageSize:this.pagination1.pageSize,
        nickName:this.nickNameSearch1,
        isHaveTerminal: false
      }
      this.request.get('/front/system/user/query',params).then(rs => {
        // console.log(rs);
        if (rs.code === 200) {
          if(rs.data&&rs.data.length){
            this.installPersonLists= rs.data
            this.showContent1 = true
            this.pagination1.total = rs.total;
          }
        } else {
          this.installPersonLists= []
          this.msg.error(rs.msg);
          this.showContent1 = true
        }
      })
    },
    getUserLists(id) {
      this.showContent = false
      this.chargePersonLists= []
      let params = {
        roleIds: id,
        page:this.pagination.currentPage,
        pageSize:this.pagination.pageSize,
        nickName:this.nickNameSearch,
        isHaveTerminal: false
      }
      this.request.get('/front/system/user/query',params).then(rs => {
        // console.log(rs);
        if (rs.code === 200) {
          if(rs.data&&rs.data.length){
            this.chargePersonLists= rs.data
            this.showContent = true
            this.pagination.total = rs.total;
          }
        } else {
          this.chargePersonLists= []
          this.msg.error(rs.msg);
          this.showContent = true
        }
      })
    },
    // ----------------------------------------------------
    //树节点选中接收值
    sendCheckNode(checkArr) {
      // console.log(checkArr)
      this.modulesCheckArr = this.delArrrys(checkArr)
      // console.log(this.modulesCheckArr)
    },
    // ----------------------------------------------------
    //树节点选中接收值
    sendCheckNode1(checkArr) {
      // console.log(checkArr)
      // console.log(this.delArrrys(checkArr));
      this.modulesCheckArr1 = this.delArrrys(checkArr)
      // console.log(this.modulesCheckArr1)
    },
    delArrrys(data){ 
        var arr=[];    //定义一个临时数组 
        for(var i = 0; i < data.length; i++){    //循环遍历当前数组 
            //判断当前数组下标为i的元素是否已经保存到临时数组 
            //如果已保存，则跳过，否则将此元素保存到临时数组中 
            if(arr.indexOf(data[i]) == -1){ 
              arr.push(data[i]); 
            } 
        } 
        return arr; 
    },
    // 全选、全不选
    chooseAll(flag) {
      console.log(flag)
      console.log(this.chargePersonLists);
      console.log(this.$refs.treeRef.$refs.treeTableTree.getCheckedNodes());
      if (flag) {
        this.$refs.treeRef.$refs.treeTableTree.setCheckedNodes(this.chargePersonLists)
      } else {
        this.$refs.treeRef.$refs.treeTableTree.setCheckedKeys([])
      }
    },
    chooseAll1(flag) {
        console.log(flag)
        console.log(this.installPersonLists);
        console.log(this.$refs.treeRef1.$refs.treeTableTree.getCheckedNodes());
        if (flag) {
          this.$refs.treeRef1.$refs.treeTableTree.setCheckedNodes(this.installPersonLists)
        } else {
          this.$refs.treeRef1.$refs.treeTableTree.setCheckedKeys([])
        }
      },
    // 树======================
    // 提交================
    cancelTreeModel(){
      this.$emit('formCancel',false)
    },
    treeEven(data){
      this.adduserForm.regionId = data.id
      this.regionName = data.label
      // console.log(this.adduserForm.regionId);
      // console.log(data);
      this.getPersonInfo(data.id)
    },
    getPersonInfo(id){
      this.sendTreeData = []
      this.sendTreeData1 = []
      this.request.get('/front/device/region/'+id).then(rs => {
        console.log(rs);
        if (rs.code === 200) {
          let dataLists =  [ ...rs.data.chargePersonList ]
          if(dataLists&&dataLists.length) {
            // dataLists.forEach(item=>{
            //   this.sendTreeData.push(item.id)
            // })
            this.sendTreeData = [...dataLists]
          }
          let dataLists1 =  [ ...rs.data.installPersonList ]
          if(dataLists1&&dataLists1.length) {
            // dataLists1.forEach(item=>{
              // this.sendTreeData1.push(item.id)
              // item.checked = true
            // })
            this.sendTreeData1 = [...dataLists1]
          }
        } else {
          this.sendTreeData = []
          this.sendTreeData1 =[]
        }
      })
    },
    // 提交================
    formSubmit() {
      let params ={
        chargePersonIdList: this.modulesCheckArr.length?this.modulesCheckArr:this.sendTreeData,
        id: this.adduserForm.regionId?this.adduserForm.regionId:0,
        installPersonIdList: this.modulesCheckArr1.length?this.modulesCheckArr1:this.sendTreeData1,
        name: this.regionName
      }
      if(this.adduserForm.regionId){
        this.$refs.adduserForm.validate((valid) => {
          if (valid) {
            this.$emit('formSubmit',params)
          } else {
            this.msg.error('请正确填写相关信息！')
            return
          }
        })
      } else{
        this.msg.error('请先选择区域！')
        return
      }
    },
    cancelHandle() {},
    //重置==========================
    resetHandle() {
      // this.$refs.addform.resetFields()
    },
     //树形结构
    normalizer(node){
      // console.log(node)
      //去掉children=null的属性
      if(node.children==null||node.children=='null'){
        delete node.children;
      }
      return {
        id: node.value,
        label: node.label,
        children: node.children&&node.children.length?node.children:'',
        isDisabled: node.id==0 ? true : false || node.terminalFlag ==1 ? true:false
      };
    }
  }
}
</script>
<style lang="scss">
.regionAddOrEdit{
  .drawerBody{
    padding: 0 20px;
    .vue-treeselect{
      width: 100%;
    }
    .el-form-item__error{
      display: none;
    }
    .addform1{
      margin-bottom: 20px;
    }
    .el-form-item__label{
      color:#222;
    }
  }
}
</style>

